// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604171403/js/" + chunkId + "." + {"44":"f87b4b92","225":"feaa715a","481":"7da95188","486":"a8d33b87","770":"be377a04"}[chunkId] + ".0.7757375530972945.chunk.js";
};